// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupFooter-module-popupFooter {
  padding: 15px;
  background-color: var(--popup-background);
  border-top: 1px solid var(--border);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Popup/components/PopupFooter/PopupFooter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yCAAyC;EACzC,mCAAmC;EACnC,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,SAAS;AACX","sourcesContent":[".popupFooter {\r\n  padding: 15px;\r\n  background-color: var(--popup-background);\r\n  border-top: 1px solid var(--border);\r\n  border-bottom-left-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  display: flex;\r\n  gap: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
export var popupFooter = `PopupFooter-module-popupFooter`;
export default ___CSS_LOADER_EXPORT___;
